import { useAppSelector } from "../../hooks";
import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function PublicRoute({
  title
}: {
  title: string;
}) {
  const { loading } = useAppSelector(
    (state) => state.auth
  );
  const navigate = useNavigate();

  useEffect(() => {
    document.title = title;
  }, []);

  useEffect(() => {
    // If loading, do nothing
    if (loading) return;

  }, [navigate, loading]);

  return <Outlet />;
}
